module.exports = __webpack_public_path__ + "img/girona-logo-icon.15bc53da.png";